export const hasRichTextContent = (value?: string | null): boolean => {
  if (!value) {
    return false
  }
  return (
    value
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim().length > 0
  )
}
